module.exports = __webpack_public_path__ + "static/media/edit.ce45c819.svg";